import { render, staticRenderFns } from "./PrivateKeysForm.vue?vue&type=template&id=456cbeff&"
import script from "./PrivateKeysForm.vue?vue&type=script&lang=js&"
export * from "./PrivateKeysForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports